module.exports = __webpack_public_path__ + "content/6549f6136af64450a3d8b5355bf70aae.png";